import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { SwiperSlide } from "swiper/react";
import { fetchPaidPartnershipPageContent } from "../../../redux/actions/company_action";
import { CompaniesSkeleton } from "./CompaniesSkeleton";
import {
  CarouselContainer,
  CompanyButtons,
  LogoContainer,
  LogoStyled,
  SwiperStyled,
  TitleContainer,
  TitleStyled,
  TrustedCompanyGrid,
} from "./styles";

let query = `
  secondSectionTitle
  featuredCompanies {
    brandLogo {
      data {
        attributes {
          url
          alternativeText
        }
      }
    }
    clickThroughURL
  }
  `;

const swiperSettings = {
  modules: [Autoplay],
  loop: true,
  slidesPerView: 3,
  spaceBetween: 30,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  speed: 3000,
  breakpoints: {
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 25,
    },
    1280: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1281: {
      slidesPerView: 6,
      spaceBetween: 15,
    },
  },
};

function LandingCompanies(props) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const isTablet = useMediaQuery("(max-width:768px)");

  const [data, setData] = useState([]);
  const firstRowCompanies = data?.featuredCompanies;

  async function fetchData() {
    const response = await dispatch(fetchPaidPartnershipPageContent(query));

    const { featuredCompanies, secondSectionTitle } = response || {};
    setData({ featuredCompanies, secondSectionTitle });
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <TrustedCompanyGrid
      container
      justifyContent={"center"}
      flexDirection={"column"}
      alignItems={isTablet ? "left" : "center"}
    >
      {loading ? (
        <>
          <CompaniesSkeleton />
        </>
      ) : (
        <>
          <TitleContainer>
            <TitleStyled
              dangerouslySetInnerHTML={{ __html: data?.secondSectionTitle }}
            />
          </TitleContainer>

          <CarouselContainer container justifyContent={"center"}>
            <SwiperStyled {...swiperSettings}>
              {firstRowCompanies?.map((company, index) => (
                <SwiperSlide key={index}>
                  <CompanyButtons
                    href={company?.clickThroughURL}
                    target="_blank"
                    rel="noopener"
                  >
                    <LogoContainer>
                      <LogoStyled
                        alt={
                          company?.brandLogo?.data?.attributes
                            ?.alternativeText ?? `company-logo-${index}`
                        }
                        src={company?.brandLogo?.data?.attributes?.url}
                      />
                    </LogoContainer>
                  </CompanyButtons>
                </SwiperSlide>
              ))}
            </SwiperStyled>
          </CarouselContainer>
        </>
      )}
    </TrustedCompanyGrid>
  );
}

export default LandingCompanies;
